module.exports = __webpack_public_path__ + "static/proweek-casestudy-7d7b935bc92f9eb6365bcaceb09f60a8.png";